import { type Language, useI18n } from '../i18n/useI18n';

const languages: { id: Language; label: string }[] = [
  { id: 'en', label: 'EN' },
  { id: 'ru', label: 'RU' },
  { id: 'kk', label: 'KK' },
];

export function LanguageSwitcher() {
  const { language, setLanguage } = useI18n();

  return (
    <div className="language-switcher" aria-label="Language">
      {languages.map((item) => (
        <button
          className={language === item.id ? 'active' : ''}
          key={item.id}
          type="button"
          onClick={() => setLanguage(item.id)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
